import React, { useEffect } from 'react';
import { FormApi } from 'final-form';
import Input, { Select, SelectItem, PhoneInput, AccountInput, Textarea } from 'ui/Input';
import { IFormValues } from './ComplaintForm.model';

const complaintData = [
  {
    name: 'Transaction Issues',
    id: 1,
  },
  {
    name: 'Customer Enquiries',
    id: 2,
  },
  {
    name: 'Setup Issues',
    id: 3,
  },
  {
    name: 'Other',
    id: 4,
  },
];

const renderSubjectSelect = () => (
  <Select name="subject" label="Subject">
    {complaintData.map(({ name, id }) => (
      <SelectItem value={name} key={id}>
        {name}
      </SelectItem>
    ))}
  </Select>
);

const renderOtherSubjectInput = () => <Input name="otherSubject" label="Other Subject" />;

const renderFullnameInput = () => <Input name="fullname" label="Full Name" />;

const renderPhonenumberInput = () => <PhoneInput name="phone" label="Phone Number" />;

const renderEmailInput = () => <Input name="email" label="E-mail Adress" optional />;

const renderAccountInput = () => <AccountInput name="accountNumber" label="Account Number" optional />;

const renderMessageArea = () => <Textarea name="message" label="Enquiry Message" />;

interface Props {
  form: FormApi<IFormValues, Partial<IFormValues>>;
  values: IFormValues;
  authenticated: boolean;
}

const RenderComplaintFields = ({ form, values, authenticated }: Props) => {
  useEffect(() => {
    if (authenticated) {
      form.mutators.changeFieldValue('fullname', sessionStorage.fullName);
      form.mutators.changeFieldValue('accountNumber', sessionStorage.accountNumber);
    }
  }, [authenticated, form.mutators]);

  return (
    <>
      {renderSubjectSelect()}
      {values.subject === 'other' ? renderOtherSubjectInput() : null}
      {renderFullnameInput()}
      {renderPhonenumberInput()}
      {renderEmailInput()}
      {renderAccountInput()}
      {renderMessageArea()}
    </>
  );
};

export default RenderComplaintFields;
